"use client";

import Image from "next/image";
import Link from "next/link";
import { parseJsonBody } from "@/lib/general.utils";
import { ArrowUpLeft, ArrowUpRight } from "lucide-react";
import { useTranslation } from "next-i18next";

interface BlogCardProps {
  blog: {
    id: number;
    title: string;
    imageUrl?: string;
    createdAt?: string;
    category?: string;
    description?: string;
    jsonBody?: string;
  };
}
const BlogCard = ({ blog }: BlogCardProps) => {
  const { t, i18n } = useTranslation("common");
  return (
    <article className="bg-white rounded-[1rem] shadow-lg overflow-hidden h-full flex flex-col">
      <Link
        href={`/blogs/${blog.id}`}
        className="relative block w-full aspect-[3/2] shrink-0"
        aria-label={blog.title}
      >
        {blog.imageUrl && (
          <Image
            src={blog.imageUrl}
            alt={blog.title}
            fill
            sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 25vw"
            className="object-cover"
          />
        )}
      </Link>
      <div className="p-[1.5rem] md:p-[2rem] flex-1 flex flex-col">
        {(blog.category || parseJsonBody(blog.jsonBody).category) && (
          <p className="text-[0.85rem] text-tertiary font-semibold mb-[0.75rem]">
            {blog.category || parseJsonBody(blog.jsonBody).category}
          </p>
        )}
        <h2 className="text-[1.2rem] md:text-[1.5rem] font-bold text-tertiary leading-[1.6] mb-[1rem] min-h-[5.76rem] md:min-h-[7.2rem] line-clamp-3">
          <Link href={`/blogs/${blog.id}`}>{blog.title}</Link>
        </h2>
        {blog.description && (
          <p className="text-[1rem] text-[#575757] leading-[1.8] line-clamp-3 mb-[1.5rem]">
            {blog.description}
          </p>
        )}
        <Link
          href={`/blogs/${blog.id}`}
          className="inline-flex items-center justify-center gap-2 self-start bg-secondary text-white text-[1rem] font-bold rounded-[0.5rem] px-[1.5rem] py-[0.75rem] mt-auto"
        >
          {t("blogsPage.readMore")}{" "}
          {i18n.language === "ar" ? (
            <ArrowUpLeft size={17} aria-hidden="true" />
          ) : (
            <ArrowUpRight size={17} aria-hidden="true" />
          )}
        </Link>
      </div>
    </article>
  );
};
export default BlogCard;
